/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { ReactNode, useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { checkIsActive } from "../../../../_helpers";
import cache from '../../../../_assets/images/cache.png';
import { useDispatch } from "react-redux";
import SaleList, { SearchFormData } from "../../../../../appStore/actions/saleList";
import { REPORT_LIST, REPORTS_PATH } from "../../../../../accounting/reportList";

const profilePaths = ["/businesses", "/agentprofile", "/consortium", "/organizations", "/taxes", "/fees", "/promotions"];
const utilityPaths = ["/register", "/email-configuration", "/set-password", "/myfiles", "/FraudCheck", "/Branding", "/report-generator", "/offline-flight/release-manager"];
const contractPaths = ["/newcontractlist", "/analyze-contracts"];
const blockPaths = ["/offline-flight/search", "/offline-flight/bookings", "/offline-flight/create", "/offline-flight/flights"];
const invoicePaths = ["/invoice"];
const reportPaths = [REPORTS_PATH];

function pathMatches(pathname: string, paths: string[]) {
  return paths.some((path) => pathname.indexOf(path) > -1);
}

export function AsideMenuList({ layoutProps }: any) {
  const dispatch = useDispatch();
  const location = useLocation();
  const [open, setOpen] = useState({
    profile: pathMatches(location.pathname, profilePaths),
    utilities: pathMatches(location.pathname, utilityPaths),
    contracts: pathMatches(location.pathname, contractPaths),
    blocks: pathMatches(location.pathname, blockPaths),
    invoice: pathMatches(location.pathname, invoicePaths),
    reports: pathMatches(location.pathname, reportPaths),
  });

  useEffect(() => {
    setOpen((current) => ({
      profile: current.profile || pathMatches(location.pathname, profilePaths),
      utilities: current.utilities || pathMatches(location.pathname, utilityPaths),
      contracts: current.contracts || pathMatches(location.pathname, contractPaths),
      blocks: current.blocks || pathMatches(location.pathname, blockPaths),
      invoice: current.invoice || pathMatches(location.pathname, invoicePaths),
      reports: current.reports || pathMatches(location.pathname, reportPaths),
    }));
  }, [location.pathname]);

  const getMenuItemActive = (url: string, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  }

  const toggle = (key: keyof typeof open) => {
    setOpen((current) => ({ ...current, [key]: !current[key] }));
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        <MenuAccordion title="Profile, Fees, Promotions" iconClass="fas fa-id-card" open={open.profile} onToggle={() => toggle("profile")}>
          <li className={`menu-item ${getMenuItemActive("/businesses", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/businesses">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">Agencies</span>
            </NavLink>
          </li>
          <li className={`menu-item ${getMenuItemActive("/agentprofile/false", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/agentprofile/false">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">Agents</span>
            </NavLink>
          </li>
          <li className={`menu-item ${getMenuItemActive("/consortium", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/consortium">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">Consortiums</span>
            </NavLink>
          </li>
          <li className={`menu-item ${getMenuItemActive("/organizations", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/organizations">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">Organisations</span>
            </NavLink>
          </li>
          <li className={`menu-item ${getMenuItemActive("/taxes", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/taxes">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">Taxes</span>
            </NavLink>
          </li>
          <li className={`menu-item ${getMenuItemActive("/fees", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/fees">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">Fees</span>
            </NavLink>
          </li>
          <li className={`menu-item ${getMenuItemActive("/promotions", false)}`} aria-haspopup="true" onClick={() => {dispatch(SaleList([])); dispatch(SearchFormData({}));}}>
            <NavLink className="menu-link" to="/promotions/loyalty">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">Promotions</span>
            </NavLink>
          </li>
        </MenuAccordion>

        <MenuAccordion title="Other Utilities" iconClass="fas fa-toolbox" open={open.utilities} onToggle={() => toggle("utilities")}>
          <li className={`menu-item ${getMenuItemActive("/register", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/register">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">SSO Agent registration</span>
            </NavLink>
          </li>
          <li className={`menu-item ${getMenuItemActive("/email-configuration", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/email-configuration">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">Ticketing & Email configurations</span>
            </NavLink>
          </li>
          <li className={`menu-item ${getMenuItemActive("/set-password", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/set-password">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">Set Cognito password</span>
            </NavLink>
          </li>
          <li className={`menu-item ${getMenuItemActive("/myfiles", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/myfiles">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">All Files</span>
            </NavLink>
          </li>
          <li className={`menu-item ${getMenuItemActive("/FraudCheck", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/FraudCheck">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">Fraud Pax</span>
            </NavLink>
          </li>
          <li className={`menu-item ${getMenuItemActive("/Branding", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/Branding">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">B2C flights UI branding</span>
            </NavLink>
          </li>
          <li className={`menu-item ${getMenuItemActive("/report-generator/dqb", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/report-generator/dqb">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">DQB report</span>
            </NavLink>
          </li>
          <li className={`menu-item ${getMenuItemActive("/offline-flight/release-manager", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/offline-flight/release-manager">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">Release management</span>
            </NavLink>
          </li>
        </MenuAccordion>

        <li className={`menu-item ${getMenuItemActive("/sunquest-cache-admin", false)}`} aria-haspopup="true">
          <NavLink className="menu-link" to="/sunquest-cache-admin">
            <span className="svg-icon menu-icon">
              <img src={cache} alt="cache" className="sunQuestMenuIcon" />
            </span>
            <span className="menu-text">Sunquest cache admin</span>
          </NavLink>
        </li>

        <MenuAccordion title="Contract Management" iconClass="fas fa-file-signature" open={open.contracts} onToggle={() => toggle("contracts")}>
          <li className={`menu-item ${getMenuItemActive("/newcontractlist", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/newcontractlist">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">Contracts</span>
            </NavLink>
          </li>
          <li className={`menu-item ${getMenuItemActive("/analyze-contracts", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/analyze-contracts">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">Contract QA utility</span>
            </NavLink>
          </li>
        </MenuAccordion>

        <MenuAccordion title="Blocks & Series Flights" iconClass="fas fa-plane" open={open.blocks} onToggle={() => toggle("blocks")}>
          <li className={`menu-item ${getMenuItemActive("/offline-flight/search", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/offline-flight/search">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">Blocks</span>
            </NavLink>
          </li>
          <li className={`menu-item ${getMenuItemActive("/offline-flight/bookings", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/offline-flight/bookings">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">Bookings</span>
            </NavLink>
          </li>
        </MenuAccordion>

        <MenuAccordion title="Invoice" iconClass="fas fa-file-invoice-dollar" open={open.invoice} onToggle={() => toggle("invoice")}>
          <li className={`menu-item ${getMenuItemActive("/invoice", false)}`} aria-haspopup="true">
            <NavLink exact className="menu-link" to="/invoice">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">Invoice</span>
            </NavLink>
          </li>
          <li className={`menu-item ${getMenuItemActive("/invoice/offices", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/invoice/offices">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">Offices</span>
            </NavLink>
          </li>
          <li className={`menu-item ${getMenuItemActive("/invoice/forms-of-payment", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/invoice/forms-of-payment">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">Forms of payment</span>
            </NavLink>
          </li>
          <li className={`menu-item ${getMenuItemActive("/invoice/suppliers", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/invoice/suppliers">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">Suppliers</span>
            </NavLink>
          </li>
          <li className={`menu-item ${getMenuItemActive("/invoice/transaction-types", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/invoice/transaction-types">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">Transaction types</span>
            </NavLink>
          </li>
          <li className={`menu-item ${getMenuItemActive("/invoice/import-check", false)}`} aria-haspopup="true">
            <NavLink className="menu-link" to="/invoice/import-check">
              <i className="menu-bullet menu-bullet-dot"><span /></i>
              <span className="menu-text">Import Check</span>
            </NavLink>
          </li>
          {/* Reports: an accordion inside Invoice, one link per report. */}
          <MenuAccordion title="Reports" open={open.reports} onToggle={() => toggle("reports")}>
            {REPORT_LIST.map((report) => (
              <li key={report.key} className={`menu-item ${getMenuItemActive(`${REPORTS_PATH}/${report.key}`, false)}`} aria-haspopup="true">
                <NavLink className="menu-link" to={`${REPORTS_PATH}/${report.key}`}>
                  <i className="menu-bullet menu-bullet-line"><span /></i>
                  <span className="menu-text">{report.title}</span>
                </NavLink>
              </li>
            ))}
          </MenuAccordion>
        </MenuAccordion>
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}

function MenuAccordion({
  title,
  iconClass,
  open,
  onToggle,
  children,
}: {
  title: string
  iconClass?: string
  open: boolean
  onToggle: () => void
  children: ReactNode
}) {
  return (
    <li
      className={`menu-item menu-item-submenu${open ? " menu-item-open menu-item-not-hightlighted" : ""}`}
      aria-haspopup="true"
      data-menu-submenu-mode="accordion"
    >
      <a
        href="#"
        className="menu-link menu-toggle"
        onClick={(event) => {
          event.preventDefault();
          onToggle();
        }}
      >
        {iconClass ? (
          <span className="svg-icon menu-icon">
            <i className={iconClass}></i>
          </span>
        ) : (
          <i className="menu-bullet menu-bullet-dot"><span /></i>
        )}
        <span className="menu-text">{title}</span>
        <i className={`menu-arrow aside-accordion-arrow${open ? " aside-accordion-arrow-open" : ""}`}>
          <i className="fas fa-angle-right" />
        </i>
      </a>
      <div className="menu-submenu">
        <ul className="menu-subnav">
          <li className="menu-item menu-item-parent" aria-haspopup="true">
            <span className="menu-link">
              <span className="menu-text">{title}</span>
            </span>
          </li>
          {children}
        </ul>
      </div>
    </li>
  );
}
